import { render } from "./WalletExchangeTradeDetails.vue?vue&type=template&id=2afaee78&scoped=true"
import script from "./WalletExchangeTradeDetails.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTradeDetails.vue?vue&type=script&lang=js"

import "./WalletExchangeTradeDetails.vue?vue&type=style&index=0&id=2afaee78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afaee78"]])

export default __exports__